import React from 'react'
import WhoHero from '../../Components/who/WhoHero'
import { Briefcase, Share2, Monitor, Factory, RotateCw } from 'lucide-react';
import UserFirstExperienceSection from '../../Components/servicex/UserFirstExperienceSection'
import ServiceX360ViewSection from '../../Components/servicex/ServiceX360ViewSection'
import ServiceXOfferingsSection from '../../Components/servicex/ServiceXOfferingsSection'
import IndustriesServiceExperienceSection from '../../Components/servicex/IndustriesServiceExperienceSection'
import WhatSetsApartSection from '../../Components/servicex/WhatSetsApartSection'
import OtherExpertLedSolutionsSection from '../../Components/servicex/OtherExpertLedSolutionsSection'
import CaseStudySection from '../../Components/servicex/CaseStudySection'
import FAQSection from '../../Components/servicex/FAQSection'
import { Helmet } from "react-helmet-async";

const serviceItems = [
    {
        id: 1,
        title: "Drive Revenue & Loyalty",
        description: "Drive revenue and loyalty through consistent, proactive service engagement across all critical touchpoints.",
        image: "https://images.unsplash.com/photo-1552664730-d307ca884978?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 2,
        title: "Unified Visibility",
        description: "Gain complete and unified visibility across end-to-end employee and customer journeys without data silos.",
        image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 3,
        title: "Reduce Service Costs",
        description: "Significantly cut operational service overheads with intelligent automation and streamlined digital workflows.",
        image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 4,
        title: "Improve Agility",
        description: "Accelerate business agility with rapid deployment and seamless rollout of modern digital services.",
        image: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1000&q=80"
    },
    {
        id: 5,
        title: "Maximize ROI",
        description: "Extract maximum return on investment and business value from enterprise platforms like ServiceNow.",
        image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?auto=format&fit=crop&w=1000&q=80"
    }
];

const solutionsData = [
    {
        id: 1,
        title: "Intelligent Operations",
        desc: "Modernize enterprise operations with connected workflows, real-time visibility, and automation that improves service performance and operational efficiency.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: 2,
        title: "Risk and Security",
        desc: "Strengthen governance, compliance, and resilience through integrated risk workflows that reduce exposure and protect critical business services.",
        image: "/assets/mumbai/item9.png",
        link: "#"
    },
    {
        id: 3,
        title: "Innovation and AI",
        desc: "Accelerate innovation with AI-driven platforms, scalable digital foundations, and new workflows that unlock growth and future-ready transformation.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    }
];

const offeringsData = [
    {
        id: 1,
        icon: Briefcase,
        title: "Enterprise IT",
        desc: "We help enterprises improve IT service delivery with strong ITSM processes. Standardize incidents, requests, changes, and problems so teams can work faster, stay consistent, and deliver better service across the organization.",
        products: ["ITSM"]
    },
    {
        id: 2,
        icon: Share2,
        title: "CX Transformation",
        desc: "We help organizations improve customer service with connected case management and CRM and CSM workflows. Resolve issues faster, support customers across channels, & interaction.",
        products: ["CSM", "CRM"]
    },
    {
        id: 3,
        icon: Monitor,
        title: "Digital Workplace",
        desc: "Create a modern digital workplace where employees access HR and support services through intuitive journeys. Improve engagement, reduce service friction, & deliver personalized internal experiences at scale.",
        products: ["HRSD", "WSD"]
    },
    {
        id: 4,
        icon: Factory,
        title: "Industrial Edge",
        desc: "We help industries activate outcome-driven workflows tailored to sector needs. Enable compliant, efficient operations across banking, retail, telecom, and manufacturing with accelerators built for real operating models.",
        products: ["FSO", "RSM", "OTM"]
    },
    {
        id: 5,
        icon: RotateCw,
        title: "Field Service Transformation",
        desc: "Transform field operations with connected scheduling, mobile execution, and automated work orders. Improve technician productivity, accelerate service delivery, and deliver reliable outcomes across asset-intensive environments.",
        products: ["FSM"]
    }
];


const industryTabs = [
    {
        id: "manufacturing",
        label: "Manufacturing",
        title: "Manufacturing",
        desc: "We help manufacturers connect service delivery across plants, assets, and frontline teams to improve operational efficiency and support smarter industrial workflows.",
        image: "/assets/mumbai/item4.png",
        link: "#"
    },
    {
        id: "bfsi",
        label: "BFSI",
        title: "BFSI",
        desc: "Empowering financial and insurance institutions with resilient digital service management, secure workflows, and personalized customer-first engagements.",
        image: "/assets/mumbai/item1.png",
        link: "#"
    },
    {
        id: "retail",
        label: "Retail",
        title: "Retail",
        desc: "Modernize inventory and omnichannel operations with scalable ServiceNow workflows designed to streamline supply chains and enhance shopper experiences.",
        image: "/assets/mumbai/item5.png",
        link: "#"
    },
    {
        id: "telecom",
        label: "Telecommunication",
        title: "Telecommunication",
        desc: "Accelerate network operations and improve customer issue resolution with automated service assurance and seamless cross-platform orchestration.",
        image: "/assets/mumbai/item7.png",
        link: "#"
    }
];

const apartData = [
    {
        id: 1,
        title: "Combination of Integrations and speed",
        desc: "ServiceX unifies service delivery across IT, HR, customer operations, and field service on one connected foundation."
    },
    {
        id: 2,
        title: "Cross Platform Capabilities",
        desc: "ServiceX unifies service delivery across IT, HR, customer operations, and field service on one connected foundation."
    },
    {
        id: 3,
        title: "Human-centered UX",
        desc: "Our Design Studio creates intuitive experiences that improve portal usage, self-service adoption, and employee satisfaction."
    },
    {
        id: 4,
        title: "AI-driven approach",
        desc: "We embed automation and AI to reduce manual effort, improve resolution speed, and continuously enhance service experiences."
    }
];


const caseStudies = [
    {
        id: 'virgin',
        name: 'Virgin Mobile',
        logoText: 'Virgin Mobile',
        image: '/assets/mumbai/img1.png',
        title: 'Unified IT and Customer Service Operations on ServiceNow for Virgin Mobile UAE',
        desc: 'Reduced service friction, improved operational efficiency, and enhanced customer satisfaction within six months of go-live.',
        link: '#',
        badges: [
            'Deflection in 730 cases',
            'Reduction in agent attrition',
            'Reduction in unfavorable experiences'
        ]
    },
    {
        id: 'ansr',
        name: 'ANSR',
        logoText: 'ANSR',
        image: '/assets/mumbai/img2.png',
        title: 'AI-Enabled Service Operations for ANSR',
        desc: 'Leveraged automation and self-service to reduce manual effort and enhance service delivery across functions.',
        link: '#',
        badges: [
            'Faster Resolution',
            'Improved Employee Satisfaction',
            'Reduced Operational Costs'
        ]
    },
    {
        id: 'entain',
        name: 'Entain',
        logoText: 'Entain',
        image: '/assets/mumbai/img3.png',
        title: 'Enterprise HR Policy Governance Transformation for Entain',
        desc: 'Aligned policy lifecycle with knowledge visibility to ensure consistency, control, and better access management.',
        link: '#',
        badges: [
            'Automated the entire policy lifecycle',
            'Aligned HR policies with governance',
            'Controlled Knowledge Base visibility'
        ]
    },
    {
        id: 'maruti',
        name: 'MARUTI SUZUKI',
        logoText: 'Maruti Suzuki',
        image: '/assets/mumbai/img4.png',
        title: 'Streamlined Dealer Finance & Audit Operations for Maruti Suzuki',
        desc: 'Enabled faster processing, real-time financial insights, and improved compliance across dealer networks.',
        link: '#',
        badges: [
            'Reduced Turnaround Time (TAT)',
            'Enhanced Transparency & Audit Readiness',
            'Instant financial exposure insights'
        ]
    }
];

const faqData = [
    {
        id: 1,
        question: "What does Experience as a Service (EaaS) mean?",
        answer: "Experience as a Service (EaaS) focuses on delivering outcomes and complete experiences rather than just standalone software or products. It combines human-centric design, intelligent workflows, and platform capabilities to continuously optimize interactions for both customers and employees."
    },
    {
        id: 2,
        question: "How does employee experience impact customer experience?",
        answer: "When employees have seamless access to tools, simplified workflows, and unified data, they resolve issues faster and communicate more effectively. A frictionless employee experience directly translates to faster response times, higher service quality, and better overall customer satisfaction."
    },
    {
        id: 3,
        question: "What technologies help improve employee experience?",
        answer: "Platforms like ServiceNow (HRSD, ITSM, Workplace Service Delivery), AI-driven virtual agents, self-service portals, and automated case management streamline everyday requests, reducing administrative friction and empowering employees to focus on high-value work."
    }
];



function Servicex() {
    return (
        <div>
            <Helmet>
    <title>ServiceNow Consulting & ServiceX Solutions | Mobikode</title>

    <meta
        name="description"
        content="Transform enterprise service experiences with Mobikode ServiceX and ServiceNow consulting. Deliver connected IT, customer, HR, workplace and field service solutions with intelligent workflows, automation and AI."
    />

    <meta
        name="keywords"
        content="ServiceNow consulting, ServiceNow implementation, ServiceNow solutions, ServiceNow partner, ServiceNow ITSM, ServiceNow CSM, ServiceNow HRSD, ServiceNow FSM, ServiceNow CRM, ServiceX, enterprise service management, digital transformation, IT service management, customer service management, employee experience, workflow automation, ServiceNow AI, ServiceNow consulting company"
    />

    <meta name="robots" content="index, follow" />
    <meta name="googlebot" content="index, follow" />

    <link
        rel="canonical"
        href="https://www.mobikode.com/servicex"
    />

    {/* Open Graph */}
    <meta
        property="og:title"
        content="ServiceNow Consulting & ServiceX Solutions | Mobikode"
    />

    <meta
        property="og:description"
        content="Connected ServiceNow and ServiceX solutions for IT, customer operations, HR, workplace and field service transformation."
    />

    <meta
        property="og:url"
        content="https://www.mobikode.com/servicex"
    />

    <meta
        property="og:type"
        content="website"
    />

    <meta
        property="og:site_name"
        content="Mobikode"
    />

    <meta
        property="og:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    <meta
        property="og:image:alt"
        content="Mobikode ServiceNow Consulting and ServiceX Solutions"
    />

    {/* Twitter */}
    <meta
        name="twitter:card"
        content="summary_large_image"
    />

    <meta
        name="twitter:title"
        content="ServiceNow Consulting & ServiceX Solutions | Mobikode"
    />

    <meta
        name="twitter:description"
        content="Mobikode delivers ServiceNow consulting and ServiceX solutions for connected enterprise service experiences."
    />

    <meta
        name="twitter:image"
        content="https://www.mobikode.com/assets/glodesk/bg2.png"
    />

    {/* Theme / Browser */}
    <meta name="theme-color" content="#ffffff" />

    {/* Structured Data */}
    <script type="application/ld+json">
        {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "ServiceNow Consulting & ServiceX Solutions",
            "serviceType": "ServiceNow Consulting",
            "description":
                "Mobikode provides ServiceNow consulting and ServiceX solutions for IT service management, customer service, HR, workplace and field service transformation.",
            "provider": {
                "@type": "Organization",
                "name": "Mobikode",
                "url": "https://www.mobikode.com/"
            },
            "areaServed": {
                "@type": "Place",
                "name": "Worldwide"
            },
            "url": "https://www.mobikode.com/servicex"
        })}
    </script>
</Helmet>
            <WhoHero
                title="For New Experiences"
                text="Increase the value of your technology investments through ServiceX connected service experiences across IT, workplace, customer operations, and the field."
                imgData="/assets/glodesk/bg2.png"
            />
            <UserFirstExperienceSection title="Deliver User-First Total Experience With ServiceX" description="Providing consistent, trust-building service for employees and customers remains a real challenge, even for organizations that believe they are doing well. Expectations evolve rapidly, and what feels best-in-class today can quickly fall behind without a unified experience foundation. That&apos;s why we created ServiceX, an expert-led capability designed to deliver transformative solutions and help organizations maximize their technology services for tangible business results." />
            <ServiceX360ViewSection title="Get a 360-degree view with ServiceX" description="Change the way your customers and employees interact with your enterprises across brand, digital and service touchpoints. ServiceX unifies experiences into one connected foundation so you can" serviceItems={serviceItems} />
            <ServiceXOfferingsSection offeringsData={offeringsData} title="Our Full-Suite of ServiceX offerings" description="With ServiceX, Mobikode helps enterprises deliver connected service experiences across every touchpoint, including IT, HR, customer operations, and field service." />
            <IndustriesServiceExperienceSection title="Transforming Service Experiences Across Industries" industryTabs={industryTabs} />
            <WhatSetsApartSection title="Mobikode for ServiceX" description="Our deep expertise across experience transformation, workflow design, and enterprise service delivery helps organizations realize faster adoption and measurable outcomes with ServiceX." apartData={apartData} />
            <OtherExpertLedSolutionsSection title="Other Expert-led Solutions" description="   Accelerate enterprise transformation with integrated, intelligent workflows engineered to drive operational resilience and business value." solutionsData={solutionsData} />
            <CaseStudySection title="Real-World Case Studies" description=" See how we help global enterprises drive measurable operational outcomes and unified service delivery." caseStudies={caseStudies} />
            <FAQSection faqData={faqData} />
        </div>
    )
}

export default Servicex
